import type {
  BrandApplication,
  BrandApplicationCounts,
  BrandApplicationStatus,
} from '@nucleus-commerce/api-client/platform';

/** Tabs of the list, in order. `pending_email` is last: those applicants have not confirmed yet. */
export const STATUS_TABS = [
  'new',
  'contacted',
  'approved',
  'rejected',
  'withdrawn',
  'pending_email',
] as const satisfies readonly BrandApplicationStatus[];

export type StatusTab = (typeof STATUS_TABS)[number];

export const DEFAULT_STATUS_TAB: StatusTab = 'new';

/** Only an application under review (new or contacted) can be approved or rejected. */
export function canDecide(application: Pick<BrandApplication, 'status'>): boolean {
  return application.status === 'new' || application.status === 'contacted';
}

/** Contacted needs a confirmed application still in review; the backend answers 409 otherwise. */
export function canMarkContacted(application: Pick<BrandApplication, 'status'>): boolean {
  return application.status === 'new';
}

/** Withdrawn works on any open application, confirmed or not. */
export function canWithdraw(application: Pick<BrandApplication, 'status'>): boolean {
  return (
    application.status === 'new' ||
    application.status === 'contacted' ||
    application.status === 'pending_email'
  );
}

/** The sidebar badge: confirmed applications nobody has picked up yet. */
export function unreadCount(counts: BrandApplicationCounts | undefined): number {
  return counts?.new ?? 0;
}
